export const enMenus = {
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt755c7d81254bfe8d/raisin-bank-logo.svg',
            alt: 'Raisin',
        },
    ],
    navItems: [
        {
            id: 'rerf3dd5-3a4c-4d78-bf4b-f0dddcgrgff',
            type: 'text',
            title: 'Banking as a Service',
            href: '/banking-as-a-service/',
        },
        {
            id: '2cfer-3a4c-4d78-bf4b-f0dlrer9fff',
            type: 'text',
            title: 'Investment as a Service',
            href: '/investment-as-a-service/',
        },
        {
            id: '2c1ddd5-3a4c-4d78-bf4b-f0ddgfgfff',
            type: 'text',
            title: 'Payment Services',
            href: '/payment-services/',
        },
        {
            id: '2cfdd5-3a4c-4d78-bf4b-f0defeff',
            type: 'text',
            title: 'About Us',
            href: '/about-us/',
        },
        {
            id: '2c1ghf5-3a4c-4d78-bf4b-f0ddwewffff',
            type: 'text',
            title: 'Careers',
            href: '/careers/',
        },
        {
            id: '2c1dfgd5-3a4c-4d78-bf4b-f0dfdf9fff',
            type: 'text',
            title: 'Press',
            href: '/press/',
        },
    ],
};
//# sourceMappingURL=enMenus.js.map